import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import QueryString from 'query-string';

import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,RespBkMthdMapp,
  TableDatePicker,exportTableToCSV} from '../function_lib/common_lib';
import Header from '../user_pages/header';
import Footer from '../user_pages/footer';
import Option_Module from '../user_pages/option_module';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';

import Comp_Workshop_Detail from '../components/comp_workshop_detail';

import Comp_Invoice_Products from '../components/comp_invoice_products';
import Comp_Ptr_Invoice from '../components/comp_ptr_invoice';
import Comp_Print_Report from './comp_print_report';

import {Comp_Auto_MachineUsers_New} from '../components/comp_auto_complete';


let loginUser="";
let userObject="";
let companyName="";
let clsOnlineOrders;

let recentSelectMachine={};
let _canSearchUri="";

let rf="0";
let queries;

class Workshops_Performance extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };
    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;

          if(props !=null){
            queries = QueryString.parse(this.props.location.search);
                  if(queries.rf!=null){
                    rf=queries.rf;
                    rf=atob(rf);
                  }

          }
      }
      _canSearchUri= this.props.match.params.name;
      //alert(_canSearchUri);
      this.state={stListUsers:[],stListStates:[],stWorkShopBasicDet:[],stListOilChange:[],stOilChangeLog:[],
        stViewInvoice:[],stRequestTime:{}};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsOnlineOrders=this;
      }

     
/* for child component funciton */

exportExcel(elementId,ignoreCol,expFileName){
  exportTableToCSV(elementId,ignoreCol,expFileName);
}

/* end of child component function */
getOilChangeRawLog(item){
  // alert(JSON.stringify(item));
  // return;
  var map=[];
  map.push({name:"curl_type",value:"getOilChangeRawLog"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
  map.push({name:"parent_id",value:btoa(item.id)});
  map.push({name:"date_group_v",value:item.date_group_v});
  map.push({name:"get_req_time",value:"1"});
  // map.push({name:"ser_from_date",value:$("#ser_from_date").val()});
  // map.push({name:"ser_to_date",value:$("#ser_to_date").val()});
  //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getOilChangeRawLog";
  CallMapMethod_CBack(clsOnlineOrders,map,function(data,msg){
    //alert(data);
    if(data!=="0" && data!==""){
      //alert("i m revised vendor ch");

          let listData=JSON.parse(data);
          //alert(JSON.stringify(listData.request_time));
          var strData="";
          //listData.invoice
          //listData["testinvoice"]=[item];
          clsOnlineOrders.setState({stOilChangeLog:listData.oil_change,stRequestTime:listData.request_time},()=>{
            
            clsOnlineOrders.forceUpdateHandler();
            RespBkMthdMapp(clsOnlineOrders,"_setbackparam","onDelProCatRel");
          })
        }
  });
}      
resetFilters(){
  // $("#ser_states").val("0");
  // $("#ser_from_date").val("");
  // $("#ser_to_date").val("");
  $("#ser_txtSearch").val("");
  clsOnlineOrders.getOilChangeReports();
}

getUsers(status="0"){
  //child component use this method loan_document_upload_comp
  var map=[];
  map.push({name:"curl_type",value:"getMachineUsers"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
  map.push({name:"user_type",value:"2"});
  //map.push({name:"ser_userType",value:$("#ser_userType").val()});
  map.push({name:"ser_text",value:$("#ser_text").val()});
  //alert(status);
  /*
  if(status!=="0"){
    map.push({name:"status",value:status});
  }
  not required as of now
  */
  map.push({name:"app_user_id",value:userObject[0].upper_id});
  map["res_func"]="callBackrrr";
  map["curl_type"]="getMachineUsers";
  CallMapMethod_CBack(clsOnlineOrders,map,function(data,msg){
    //alert(data);
      if(data!=="0" && data!==""){
          let listData=JSON.parse(data);
          var strData="";
          clsOnlineOrders.setState({stListUsers:listData},()=>{
            //window.getPagination("#tbData");
            clsOnlineOrders.forceUpdateHandler();
            //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
           
          
          });
        }
  });
}


getStates(){
  var map=[];
  map.push({name:"curl_type",value:"getStates"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
  map["res_func"]="callBackrrr";
  map["curl_type"]="getStates";
  CallMapMethod_CBack(clsOnlineOrders,map,function(data,msg){
    //alert(data);
      if(data!=="0" && data!==""){
         let lsData=JSON.parse(data);
         clsOnlineOrders.setState({stListStates:lsData})
        }
  });
}

getOilChangeReports(isSearch={})
{
 // alert(JSON.stringify(isSearch));
  if(isSearch===null){
    //alert("Select Workshop..");
    //alert("I am in null");
    clsOnlineOrders.setState({stListOilChange:[],stWorkShopBasicDet:[],stGpsData:[]})
    recentSelectMachine={};
    return;
  }
  
  if(typeof isSearch.id==="undefined" && typeof recentSelectMachine.id==="undefined"){
    alert("Select Workshop..");
    return;
  }
  if(typeof isSearch.id!=="undefined"){
    recentSelectMachine=isSearch;
  }

  //alert($("#ser_filter_option").val());
  
  //alert(JSON.stringify(recentSelectMachine));
        var map=[];
        map.push({name:"curl_type",value:"getPerformanceByWorkShopId"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"gb_token",value:userObject[0].app_user_id});

        map.push({name:"ser_users",value:btoa(recentSelectMachine.id)});
        map.push({name:"ser_filter_option",value:$("#ser_filter_option").val()});
        //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
        map.push({name:"courier_list",value:"yes"});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getPerformanceByWorkShopId";
        
          //alert("search on");
          // map.push({name:"ser_states",value:$("#ser_states").val()});
          //map.push({name:"ser_payment_status",value:$("#ser_PaymentStatus").val()});
          // map.push({name:"ser_from_date",value:$("#ser_from_date").val()});
          // map.push({name:"ser_to_date",value:$("#ser_to_date").val()});
          map.push({name:"ser_txtSearch",value:$("#ser_txtSearch").val()});
        
        CallMapMethod_CBack(clsOnlineOrders,map,function(data,msg){
          //alert(msg);
            if(data!=="0" && data!==""){
              
                let listData=JSON.parse(data);
              // alert(JSON.stringify(listData.gps_data));
                var strData="";
                clsOnlineOrders.setState({stWorkShopBasicDet:listData.workshop_det,
                stListOilChange:listData.oil_change,stGpsData:listData.gps_data},()=>{
                  clsOnlineOrders.forceUpdateHandler();
                })
              }
        });
}
componentDidMount(){
  this.getStates();
  this.getUsers();
  //this.getOilChangeReports();

  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
$('#divInvoiceProducts').on('hidden.bs.modal', function () {
  //window.location.reload();
  // do something…
});
}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row content12 mt-2 mb-2">
<div className="col-lg-4 col-md-4 col-sm-4 float-right">
<Comp_Auto_MachineUsers_New onChangeBack={this.getOilChangeReports} propSelected={_canSearchUri} userObject={userObject} comp_id={"ser_m_users"} comp_name={"ser_m_users"} target_obj={"ser_m_users_id"} placeHolder={"Workshop Name/Id"} propClass={"form-control1 form-control-sm1"}/>
{/* <select onChange={()=>this.getOilChangeReports()}  className="form-control form-control-sm" id="ser_users" name="ser_users">
<option value={"0"}>-Select Workshop-</option>
{this.state.stListUsers.map((item,index)=>{
  return <option value={btoa(item["id"])}>{item["business_name"]+"/"+item["dealer_code"]}</option>
})}

</select> */}
</div>
{/* 
<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <input autoComplete='off' type="text" id="ser_txtSearch" name="ser_txtSearch" rf="#btnProSearch" className="_setSearchKeyUp keyEvent_btn form-control form-control-sm" placeholder='Dealer Code/Name/City' />
             </div>
         </div>

</div> */}

<div className="col-lg-3 col-md-3 col-sm-3 float-right">
<select  className="form-control form-control-sm" id="ser_filter_option" name="ser_filter_option">
<option value={"0"}>-Filter By-</option>
<option selected={rf==="last_15"} value={"last_15"}>Last 15 days</option>
<option selected={rf==="last_month"} value={"last_month"}>Last Month</option>
<option selected={rf==="this_month"} value={"this_month"}>This Month</option>
<option selected={rf==="last_week"} value={"last_week"}>Last Week</option>
<option selected={rf==="this_week"} value={"this_week"}>This Week</option>
                                                
</select>
</div>

{/* 
<div className='col-lg-4 col-md-4 col-sm-6 float-right'>
<div className="form-group">
         <div className="input-group">
         <TableDatePicker refName="ser_from_date" />
               
               -TO-
               <TableDatePicker refName="ser_to_date"/>
             </div>
         </div>
</div> */}


<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 <div id="btnProSearch" name="btnProSearch" onClick={()=>this.getOilChangeReports(true)}  style={{marginRight:"10px"}} className="btn btn-sm btn-danger">Search</div>
                 <div onClick={()=>this.resetFilters()} className="btn btn-sm btn-danger">Reset</div>
                 </div>
               </div>
             </div>

</div>

<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 {/* <div id="btnProSearch" name="btnProSearch"  style={{marginRight:"10px"}} className="btn btn-sm btn-secondary">Export Pdf</div> */}
                 {/* <div className="btn btn-sm btn-primary">Export Excel</div> */}
                 </div>
               </div>
             </div>

</div>

    </div>
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="card">
              {/* <!-- /.card-header --> */}
              <Comp_Workshop_Detail workshop_gps={this.state.stGpsData} workshop_det={this.state.stWorkShopBasicDet} />
           <div class="card-header bg-cyan">
                <h3 class="card-title "> <b>Date Wise Workshop Performance</b></h3>

                <div onClick={()=>this.exportExcel("tbOilChange","Date Wise Workshop Performance","Workshop_Performance_Data_CSV")} className="btn btn-sm btn-danger float-right">Export Excel</div>
          
              </div>
              
               
              <table id="tbOilChange" class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive">
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>Workshop Name</th>
                      <th>Workshop Id</th>
                      {/* <th>Device IMEI.</th> */}
                      <th>State</th>
                      <th>City</th> 
                      <th>Valid Oil Changes</th>
                      <th>Date</th> 
                      
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody id="tbData">
                    {this.state.stListOilChange.map((item,index)=>{
                      return(<tr>
                        <td>{index+1}</td>
                    <td>{item.business_name}</td>
                  <td>{item.dealer_code}</td>
                  {/* <td>{item.device_id}</td> */}
                  <td>{item.state_name}</td>
                  <td>{item.city_name}</td>
                  <td>{item.oil_change}</td>
                  <td>{item.fmt_date_group_v}</td>
                  <td> 
                  <a class="dropdown-item" onClick={()=>this.getOilChangeRawLog(item)} data-toggle="modal" data-target="#divPrintReport" href="javascript:void(0)">View Log</a>
                  </td>
                    </tr>)
                    })}
                  </tbody>
                </table>
             
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Footer/>
<div className="modal fade bd-example-modal-xl"  id="divEmployee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-xl" role="document">
    <div className="modal-content">
    <div className="modal-header bg-primary">
        <h5 className="modal-title text-white" id="exampleModalLabel">Add New</h5>
        <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" className="text-white">&times;</span>
        </button>
      </div>
      <form id="frmCreate" name="frmCreate">
     
      <div className="modal-body">
      <div className="row">
                {/* <!-- left column --> */}
                <div className="col-md-12">
                    <div className="card card-danger">
                            <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                            <input type="hidden" name="curl_type" id="curl_type" value="createLogMaster" />
                            <input type="hidden" name="m_type" id="m_type" value="createLogMaster" />
                            <input type="hidden" name="type_id" id="type_id" value="2" />
                            <input type="hidden" name="app_user_id" id="app_user_id" value="" />
                            <div className="card-body">
                                <div className="row">
                               
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">License/Registration Name</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="details" name="details" className="form-control" placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Type *</label>
                                            <div className="input-group input-group-sm">
                                                <select id="parent_id_reg" name="parent_id_reg" className="form-control">
                                                  <option value="0">-Select-</option>
                                                  <option value="entity">Entity</option>
                                                  <option value="contractor">Contractor</option>
                                                  <option value="client">Client</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-12">
            <div className="form-group">
              <label for="exampleInputEmail1">Valid From</label>
              <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text"><i className="fa fa-calendar"></i></span>
                    </div>
                    <input type="text" id="col98" name="col98" className="form-control" data-inputmask-alias="datetime" data-inputmask-inputformat="dd/mm/yyyy" data-mask />
                  </div>
              <small id="emailHelp" className="form-text text-muted">Proposal Form Sign Date</small> </div>
          </div>
                                    <div className="col-lg-3 col-md-3 col-12">
            <div className="form-group">
              <label for="exampleInputEmail1">Valid To</label>
              <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text"><i className="fa fa-calendar"></i></span>
                    </div>
                    <input type="text" id="col98" name="col98" className="form-control" data-inputmask-alias="datetime" data-inputmask-inputformat="dd/mm/yyyy" data-mask />
                  </div>
              <small id="emailHelp" className="form-text text-muted">Proposal Form Sign Date</small> </div>
          </div>
                                    <div className="col-lg-12 col-md-12">
                                    <div className="form-group">
<label for="exampleInputFile">Upload Proof(*img,pdf)</label>
<div className="input-group">
  <div className="custom-file">
    <input type="file" className="custom-file-input" name="exampleInputFile" id="exampleInputFile" />
    <label className="custom-file-label" for="exampleInputFile">Choose file</label>
  </div>
  {/* <div className="input-group-append">
  <button type="button" className="btn btn-primary">Upload Now</button>
  </div> */}
</div>
</div>
                                    </div>
                                    <div className="col-lg-3 col-md-6">
                                    <div className="form-group">
                                            <label for="exampleInputEmail1">Reminder Breif(Days) *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="ref1_id" name="ref1_id" className="form-control" placeholder="Priority Index" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              
                                <div className="col-md-6 respSSL"></div>
                                <div id="testing2dd2222"></div>
                            </div>
                        
                    </div>
                </div>
            </div>
      </div>
      <div className="modal-footer">
      <div id="getReponse" style={{color:"red"}}></div>
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" className="btn _btnSetColor btn-primary">Save changes</button>
      </div>
      </form>
    </div>
    </div>
    </div>
   <Comp_Print_Report
   ptrColumnHeader={["Workshop Name","Workshop Id","Runtime","Sensor Signal","Location","Status","Date"]} 
    ptrColumnName={["business_name","dealer_code","on_off_duration","jar_switch_count","gps_lat_long","sys_valid_oil_change","fmt_entry_date"]}
    totals={[{"col":"Sub Total","col_index":11,"total_value":0},
      {"col":"Pack","col_index":14,"total_value":0},
      {"col":"Amount","col_index":15,"total_value":0}
    ]}
  
    
    ptrOutStandingCols={{"Item":"Product","Item Unit":"Unit","Quantity":"Net Quantity","Sub Total":"Net Amount"}}
    lsOutStandingData={this.state.stOutStanding}
    ptrOutStandingTitle={"Product/Unit Wise Outstanding"}
    
    lsTabelData={this.state.stOilChangeLog}
    ptrTitle={"Regional Analysis"}
    request_time={this.state.stRequestTime}
    pageType="1"
     logUser={userObject}
   />
    {/* <Comp_Ptr_Invoice app_user_id={userObject[0].app_user_id} ref_invoiceId={this.state.stRefInvoice} /> */}
          </div>)
      }
}
export default Workshops_Performance;